import { render, staticRenderFns } from "./login-auth.vue?vue&type=template&id=5281f268&scoped=true&"
import script from "./login-auth.vue?vue&type=script&lang=js&"
export * from "./login-auth.vue?vue&type=script&lang=js&"
import style0 from "./login-auth.vue?vue&type=style&index=0&id=5281f268&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5281f268",
  null
  
)

export default component.exports